export default __webpack_public_path__ + "static/media/038-forbidden city.566ccf90.svg";